import EventBus from 'EventBus';

export class Pixel {
    constructor() {
        EventBus.subscribe('add_item:insales:favorites_products', () => {
            Pixel.whenAddToFavorite();
        });

        EventBus.subscribe('add_items:insales:cart', () => {
            Pixel.whenAddToCart();
        });

        document.querySelectorAll('.social-link').forEach(button => {
            button.addEventListener('click', () => {
                Pixel.whenClickToSocialButton();
            });
        });

        document.querySelectorAll('.buyer-button').forEach(button => {
            button.addEventListener('click', () => {
                Pixel.whenCreateOrder();
            });
        });

        // WARN: Некоторые методы вызываются извне
    }

    static whenAddToCart() {
        window._txq = window._txq || [];
        window._txq.push([ 'track', 'korzina' ]);
    }

    static whenCreateOrder() {
        window._txq = window._txq || [];
        window._txq.push([ 'track', 'pokupka' ]);
    }

    static whenAddToFavorite() {
        window._txq = window._txq || [];
        window._txq.push([ 'track', 'izbrannoe' ]);
    }

    static whenClickToSocialButton() {
        window._txq = window._txq || [];
        window._txq.push([ 'track', 'soc_seti' ]);
    }

    static whenCreateAccount() {
        window._txq = window._txq || [];
        window._txq.push([ 'track', 'registr' ]);
    }

    static whenLogin() {
        window._txq = window._txq || [];
        window._txq.push([ 'track', 'vhod' ]);
    }

    static whenCreateSubscribeInFooter() {
        window._txq = window._txq || [];
        window._txq.push([ 'track', 'podpis' ]);
    }
}
